module.exports = __webpack_public_path__ + "img/title.87168459.png";